import { Link } from 'react-router-dom';

const footerLinks = {
  products: {
    title: '商品分类',
    links: [
      { label: '发酵黄油', href: '/categories?tab=fermented' },
      { label: '无盐黄油', href: '/categories?tab=unsalted' },
      { label: '动物黄油', href: '/categories?tab=animal' },
      { label: '进口黄油', href: '/categories?tab=imported' },
      { label: '有机黄油', href: '/categories?tab=organic' },
    ],
  },
  knowledge: {
    title: '黄油知识',
    links: [
      { label: '发酵黄油知识', href: '/articles/1' },
      { label: '烘焙入门指南', href: '/articles/2' },
      { label: '动物黄油科普', href: '/articles/3' },
      { label: '全球产区巡礼', href: '/articles/5' },
    ],
  },
  about: {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '联系我们', href: '/about#contact' },
      { label: '用户评价', href: '/about#testimonials' },
    ],
  },
  support: {
    title: '服务支持',
    links: [
      { label: '配送说明', href: '/articles/4' },
      { label: '售后政策', href: '/about' },
      { label: '常见问题', href: '/about#faq' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-secondary-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 text-background-50 mb-4 whitespace-nowrap">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-cake-2-line text-2xl text-primary-400"></i>
              </div>
              <span className="text-lg font-heading font-semibold">在线黄油</span>
            </Link>
            <p className="text-sm text-secondary-300 leading-relaxed mb-4">
              正品黄油在线选购平台，精选全球优质黄油，冷链直达，品质保证。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 text-secondary-200 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 text-secondary-200 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 text-secondary-200 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200" aria-label="小红书">
                <i className="ri-reddit-line text-sm"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([key, section]) => (
            <div key={key}>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">{section.title}</h4>
              <ul className="flex flex-col gap-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">
            &copy; {new Date().getFullYear()} 在线黄油 版权所有 | 正品黄油在线选购平台
          </p>
          <div className="flex items-center gap-4 text-xs text-secondary-400">
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">服务条款</a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">ICP备案号</a>
          </div>
        </div>
      </div>
    </footer>
  );
}